module.exports = __webpack_public_path__ + "static/img/vip-img2.3db0fa5.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/vip-img2.png
// module id = Hu32
// module chunks = 1